// Global CSS
import "./src/styles/global.css"
import "@fortawesome/fontawesome-svg-core/styles.css"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "slick-carousel/slick/slick-theme.css"

// Load GTM after initial render
export const onClientEntry = () => {
  if (typeof window === "undefined") return

  const loadGTM = () => {
    if (window.gtmLoaded) return
    window.gtmLoaded = true

    const script = document.createElement("script")
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KC4KB6J');
    `
    document.head.appendChild(script)
  }

  // Delay GTM 4s OR until browser idle
  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadGTM)
  } else {
    setTimeout(loadGTM, 4000)
  }
}

export function onRouteUpdate({ location, prevLocation }) {
  if (typeof window === "undefined") return

  // Scroll to top on route change
  if (prevLocation && location.pathname !== prevLocation.pathname) {
    window.scrollTo(0, 0)
  }
} 